import React from 'react'
import styles from './signup.module.css'
import { push } from 'gatsby-link'
import { createSubscriber } from '../services'
import className from 'classnames'

export default class Signup extends React.Component {

  state = {
    email: '',
    error: null,
    loading: false,
  }

  validateEmail = email => {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
  }

  handleEmailChange = evt => {
    this.setState({ email: evt.target.value, error: null })
  }

  handleSignup = evt => {
    evt.preventDefault()

    if (this.state.email == '') {
      return
    }

    if (!this.validateEmail(this.state.email)) {
      this.setState({ error: 'That doesn\'t look like a valid email address' })
      return
    }

    this.setState({ loading: true })

    createSubscriber(this.state.email).then(data => {
      if (!data.metadata.success) {
        this.setState({ error: data.metadata.message, loading: false })
        return
      } else {
        push('/signup-success')
      }
    })
  }

  render() {
    let btnClass = className('btn', 'btn-primary', 'input-group-btn', 'btn-lg', {
      'loading': this.state.loading
    })
    let groupClass = className('form-group', {
      'has-error': this.state.error
    })

    return (
      <div className={styles.root}>
        <h5 style={{textAlign: "center"}}>Join the waitlist</h5>
        <div className={groupClass}>
          <div className="input-group">
            <input
              className="form-input input-lg"
              placeholder="Enter email address"
              type="text"
              value={this.state.email}
              onChange={this.handleEmailChange}
            />
          </div>
          <div style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "12px"
          }}>
            <button
              className={btnClass}
              style={{
                borderRadius: "25px",
                justifyContent: 'center',
                width: '80%',
                backgroundColor: '#444643'
              }}
              type="button"
              onClick={this.handleSignup}
            >
              {
                this.state.loading ? (
                  null
                ) : (
                  <p style={{
                    color: 'white',
                    fontSize: 18,
                    fontWeight: '400',
                    textTransform: 'uppercase'
                  }}>
                    Sign Up
                  </p>
                )
              }
            </button>
          </div>
          {
            this.state.error ? (
              <p style={{margin: "8px", textAlign: "center"}} className="form-input-hint">{this.state.error}</p>
            ) : (
              null
            )
          }
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/signup.js